import React from 'react';
import PropTypes from 'prop-types';
import ProgressBar from '../elements-progressbar/ProgressBar';
import { get, map } from 'lodash';
import { addASpaceCreateToc } from './data/toc';
import { FormattedMessage } from 'react-intl';

const AddASpaceCreateToc = ({ spaceId, space, profile }) => {
  const firstName = get(profile, 'data.first_name', '');
  const completionPercentage = get(space, 'data.completion_percentage', 0);
  const missingItems = get(space, 'completionStatus.data.missing', []);
  const ctx = {
    missingItems,
    completionPercentage,
    space: get(space, 'data', {}),
    profile: get(profile, 'data', {})
  };

  const rows = addASpaceCreateToc(spaceId).map((item) => ({
    item,
    isComplete: item.isComplete(ctx),
    hidden: !!(item.shouldHide && item.shouldHide(ctx))
  }));

  // The first row that's required, visible, and not done yet — the row the
  // checklist should point the host to next. Optional and hidden rows can
  // never hold this spot, so they can't block progress to later rows.
  const blockIndex = rows.findIndex(({ item, isComplete, hidden }) => item.isRequired && !hidden && !isComplete);
  const targetIndex = -1 === blockIndex ? rows.length : blockIndex;

  let currentNumber = 0;

  return (
    <div>
      <ProgressBar width={completionPercentage || 5} />
      <h2>
        <FormattedMessage
          id="hosting.add_a_space_create_toc.tell_us_about_your_space_heading"
          defaultMessage="{firstName}, tell us about your space."
          values={{ firstName: firstName }}/>
      </h2>
      <p><FormattedMessage id="hosting.add_a_space_create_toc.share_space_text" defaultMessage="The more you share, the faster you can get a booking."/></p>
      <div className="margin-xl-top">
        {
          map(rows, ({ item, isComplete, hidden }, index) => {
            const itemId = (item || {}).id;

            if (hidden) {
              return null;
            }
            currentNumber++;

            // Reached = nothing ahead of this row is still blocking progress.
            const showStart = !isComplete && index <= targetIndex;

            return (
              <div className="TocRow flex middle space-between" key={itemId}>
                <div className="flex-basis-80 flex middle">
                  <div className="margin-lg-right">
                    {
                      isComplete ?
                        <i className="icon-confirmed-check ico-lg text-green-200" /> :
                        <div className="tocCircle" />
                    }
                  </div>
                  <div>
                    <div className="text-large heavier">{currentNumber}. {item.header}</div>
                    <div>{item.description}</div>
                  </div>
                </div>
                <div className="flex-basis-10 text-right">
                  {
                    isComplete ?
                      <a
                        href={item.link}
                        data-testing-id={item.id}
                        className="btn btn-link text-primary btn-block"
                      ><FormattedMessage id="hosting.add_a_space_create_toc.edit_link_text" defaultMessage="Edit"/></a>
                      : showStart
                      && <a href={item.link} className="btn btn-primary btn-block">
                        <FormattedMessage id="hosting.add_a_space_create_toc.start_link_text" defaultMessage="Start"/>
                      </a>
                  }
                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

AddASpaceCreateToc.propTypes = {
  spaceId: PropTypes.string,
  space: PropTypes.object,
  profile: PropTypes.object
};

export default AddASpaceCreateToc;
